import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-service-included",
  templateUrl: "./service-included.component.html",
  styleUrls: ["./service-included.component.scss"],
})
export class ServiceIncludedComponent implements OnInit {
  @Input() groupedService: any;
  @Input() selectedPackage: any;
  @Input() isServiceIncluded: boolean = false;
  @Output() action = new EventEmitter();


  ngOnInit(): void {
    console.log('groupedService', this.groupedService, 'isServiceIncluded', this.isServiceIncluded, 'selectedPackage', this.selectedPackage);
    this.selectedPackage =  this.selectedPackage?._healthPackage ? this.selectedPackage?._healthPackage : this.selectedPackage;
    // this.selectedPackage._healthPackag.instructions = [{locale: 'en', instruction: 'View build uploads progress including warnings, errors and upload logs.'}, {locale: 'ar', instruction: ''}]
  }

  public closeModal(ev) {
    this.action.emit(ev);
  }
}
